import ApiService, { HTTPMethod } from './api.core'
import { buildQueryParamsUrl } from '../services/utils'

class AccountApi {
  async sendChangeEmailConfirmation(userId, token, oldEmail, newEmail) {
    let urlEncoded = buildQueryParamsUrl('auth/email/confirm', {
      userId: userId,
      token: token,
      oldEmail: oldEmail,
      newEmail: newEmail,
    })
    return ApiService.fetch(urlEncoded, HTTPMethod.GET)
  }

  async sendChangeEmailConfirmationWithPassword(
    userId,
    token,
    oldEmail,
    newEmail,
    password
  ) {
    let urlEncoded = buildQueryParamsUrl('auth/email/confirm', {
      userId: userId,
      token: token,
      oldEmail: oldEmail,
      newEmail: newEmail,
    })
    return ApiService.fetch(urlEncoded, HTTPMethod.POST, {
      password: password,
    })
  }

  async changeEmail(email, confirmEmail, password) {
    return ApiService.fetch('auth/email', HTTPMethod.POST, {
      new_email: email,
      confirmed_email: confirmEmail,
      password: password,
    })
  }

  async changeEmailAdmin(email, confirmEmail) {
    return ApiService.fetch('auth/emailAdmin', HTTPMethod.POST, {
      new_email: email,
      confirmed_email: confirmEmail,
    })
  }
}

export default new AccountApi()
